
import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';

export interface AppHeaderProps extends React.ComponentPropsWithRef<'div'> {
  /** Pass your content into the header area here. For example, <AppBanner/>, <AppToolbar/> */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** AppHeader component. */
const AppHeader = React.forwardRef<HTMLElement, AppHeaderProps>((props, ref) => getContext(({ theme }: { theme?: any }) => {
  const {
    children,
    theme: propTheme,
    ...otherProps
  } = props;
  const resolvedTheme: any = _merge({}, theme.APP_BANNER, propTheme.APP_BANNER);
  return <Styled.Header ref={ref} theme={resolvedTheme} {...otherProps}>{children}</Styled.Header>;
}));

AppHeader.displayName = 'AppHeader';
AppHeader.defaultProps = {
  theme: {},
};

export default AppHeader;
